import { ReactNode } from 'react';
import { Link } from 'react-router-dom';

interface AuthLinkProps {
  to: string;
  children: ReactNode;
}

/** The accent-coloured way back to another auth screen. */
export const AuthLink = ({ to, children }: AuthLinkProps) => (
  <Link
    to={to}
    className="font-semibold text-auth-accent hover:underline focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-auth-accent"
  >
    {children}
  </Link>
);
